import React from 'react';

interface PageHeaderProps {
  /** Titre principal de la page */
  title: React.ReactNode;
  /** Sous-titre optionnel affiché sous le titre */
  subtitle?: React.ReactNode;
}

/**
 * En-tête de page standardisé (titre + sous-titre) affiché par-dessus le
 * HeroBackground. Mise en forme unique pour toutes les pages, reprise du
 * modèle de la page Pèlerinages.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => (
  <div className='relative flex flex-col items-center justify-center text-center px-4 py-6'>
    <h1 className='text-white text-3xl md:text-4xl font-light tracking-wider uppercase mb-2 drop-shadow-lg'>
      {title}
    </h1>
    {subtitle && (
      <p className='text-white text-base md:text-lg opacity-80 max-w-2xl'>
        {subtitle}
      </p>
    )}
  </div>
);
